module.exports = __webpack_public_path__ + "img/06.c0e42a5d.jpg";